// Disable Object.freeze globally to prevent "object is not extensible" and
// "Cannot assign to read only property" errors caused by Angular 18 / NgRx /
// TransferState freezing HTTP response objects during SSR hydration.
(Object as any).freeze = <T>(obj: T): T => obj;

import '@angular/compiler';
import "hammerjs";
import { enableProdMode } from "@angular/core";
import { environment } from "./environments/environment";

import { platformBrowserDynamic } from "@angular/platform-browser-dynamic";
import { RootBrowserModule } from "./app/root/root-browser.module";
import { ShellDomainProvider } from "@ecap3/core";

if (environment.production) {
  enableProdMode();
}

if (window) {
  window["shellDomain"] = environment;
  ShellDomainProvider["api"] = environment;
} else {
  process.env["shellDomain"] = JSON.stringify(environment);
}



try {
    await platformBrowserDynamic().bootstrapModule(RootBrowserModule);
} catch (err) {
    console.error('BOOTSTRAP CATCH:', err);
}
